// ! THIS API MAY DEFFER TO YOURS, CONSIDER CHANGING IT !
export const API_URL = process.env.REACT_APP_BASE_API_URL;
//export const TTS_API_URL = "https://text-to-speech.genimi.io/";
//export const TTS_API_URL = "http://127.0.0.1:8000/api/v1/";
export const TTS_API_URL = process.env.REACT_APP_BASE_API_URL;
